export const getApiError = (ex: any): string =>
  ex?.response?.data?.messages?.join('\n') || ex?.response?.data?.exception || ex?.message
